import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { interviewsApi } from '@/api/sp/interviews';
import type {
  IInterviewSPInitialState,
  IThunkAPI,
  IInterviewAvailableSlot,
  ISetInterviewSlotForSP,
} from '@/store/types';
import { isFulfilledAction, isPendingAction } from '@/helpers';

export const initialState: IInterviewSPInitialState = {
  interviewAvailableSlots: [],
  selectedDate: '',
  selectedCampaign: 0,
  selectedInterviewId: 0,
  selectedApplicationId: 0,
  isLoading: false,
};

export const getAvailableInterviewSlotsByCampaignId = createAsyncThunk<
  { result: IInterviewAvailableSlot[] },
  { campaignId: number },
  IThunkAPI
>('SP/interview/list/campaign', async ({ campaignId }, thunkAPI) => {
  try {
    const response = await interviewsApi.getAvailableInterviewSlotsByCampaignId(campaignId);
    return response.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

export const saveInterviewSlotSelection = createAsyncThunk<any, ISetInterviewSlotForSP, IThunkAPI>(
  'SP/interview/selection/set',
  async (payload, thunkAPI) => {
    try {
      const response = await interviewsApi.saveInterviewSlotSelection(payload);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const interviewSPSlice = createSlice({
  name: 'SPInterviewSlice',
  initialState,
  reducers: {
    setInterviewSlot(state, action) {
      state.interviewAvailableSlots = action.payload;
    },
    setSelectedCampaign(state, action) {
      state.selectedCampaign = action.payload;
    },
    setSelectedDate(state, action) {
      state.selectedDate = action.payload;
    },
    setInterviewId(state, action) {
      state.selectedInterviewId = action.payload;
    },
    setApplicationId(state, action) {
      state.selectedApplicationId = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getAvailableInterviewSlotsByCampaignId.fulfilled, (state, action) => {
      state.interviewAvailableSlots = action.payload.result as IInterviewAvailableSlot[];
      state.interviewAvailableSlots = action.payload.result.map(slot => {
        return {
          ...slot,
          action: 0,
        };
      });
    });
    builder.addMatcher(isPendingAction, (state, action) => {
      if (action.type === 'get/SP/interview/list/pending') state.isLoading = true;
    });
    builder.addMatcher(isFulfilledAction, (state, action) => {
      if (action.type === 'get/SP/interview/list/fulfilled') state.isLoading = false;
    });
  },
});

export const { setInterviewSlot, setSelectedDate, setSelectedCampaign, setInterviewId, setApplicationId } =
  interviewSPSlice.actions;

export default interviewSPSlice.reducer;
